// Miroir de front end/teqa_confirmation/src/api/authConfig.js — centralise
// les routes API et le switch dev/prod pour éviter les URLs codées en dur
// éparpillées dans src/api/auth.js.

// Mode dev : n'active l'injection du token Authorization que si demandé
// explicitement via l'env, ou en dev local sans opt-out. Ne JAMAIS
// committer de vrai token — DEV_TOKEN vient d'un .env local (voir
// .env.example) ou de localStorage("token").
//
// IMPORTANT : quand IS_DEV est vrai, CE token est envoyé en
// Authorization: Bearer sur CHAQUE requête, sur TOUTES les instances axios.
// Le backend (CookieJWTAuthentication) vérifie le header Authorization
// AVANT le cookie access_token — donc tant que ce header est présent, la
// vraie session cookie de l'utilisateur (login/logout/permissions/suppression
// de cookie) est totalement ignorée, peu importe qui est réellement connecté
// dans le navigateur. Ne JAMAIS committer un vrai JWT ici — IS_DEV doit
// rester à false sauf besoin ponctuel de contourner un cookie cross-domain
// cassé en local.
const envFlag = process.env.REACT_APP_IS_DEV;

export const IS_DEV = ["true", "1", "yes", "on"].includes(
  String(envFlag || "").trim().toLowerCase()
);
export const DEV_TOKEN = IS_DEV ? process.env.REACT_APP_DEV_TOKEN || "" : "";

export const AUTH_BASE_URL =
  process.env.REACT_APP_AUTH_BASE_URL || "https://auth.teqa.net/auth/";

export const INTEGRATION_API_BASE_URL =
  process.env.REACT_APP_INTEGRATION_API_BASE_URL ||

  "https://integration.teqa.net/api/";

export const INTEGRATION_BASE_URL =
  process.env.REACT_APP_INTEGRATION_BASE_URL ||
  "https://integration.teqa.net/";

export const DELIVERY_BASE_URL =
  process.env.REACT_APP_DELIVERY_BASE_URL || "https://delivery.teqa.net/";

export const MARKETPLACE_BASE_URL =
  process.env.REACT_APP_MARKETPLACE_BASE_URL || "https://marketplace.teqa.net/api/";

export const LOGIN_REDIRECT_URL =
  process.env.REACT_APP_LOGIN_URL || "https://teqa.net/login";
